import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules} from '@angular/router';
import { HomeModule } from './home/home.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { SettingsModule } from './settings/settings.module';
import { ReportsModule } from './reports/reports.module';
import { SchedulingModule } from './scheduling/scheduling.module';
import { AdministrationModule } from './administration/administration.module';
import { LoggedInGuard } from './logged-in-guard';


export const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "home",
    loadChildren: () => HomeModule
  },
  {
    path: "dashboard",
    canMatch: [LoggedInGuard],
    loadChildren: () => DashboardModule
  },
  {
    path: "settings",
    canMatch: [LoggedInGuard],
    loadChildren: () => SettingsModule
  },
  {
    path: "reports",
    canMatch: [LoggedInGuard],
    loadChildren: () => ReportsModule
  },
  {
    path: "scheduling",
    canMatch: [LoggedInGuard],
    loadChildren: () => SchedulingModule
  },
  {
    path: "administration",
    canMatch: [LoggedInGuard],
    loadChildren: () => AdministrationModule
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
